import { Component, computed, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ICONS, IconName, isStackPart } from '../icon-registry';

// One generic icon component, data-driven by the ICONS registry (icon-registry.ts).
// Replaces the ~70 hand-written per-icon components: use `<app-icon name="edit" />`.
// `name` is type-checked against the registry keys, so typos fail at build time and
// editors autocomplete the available names.
@Component({
    selector: 'app-icon',
    template: `
        <div [attr.title]="title()">
            @for (part of def(); track $index) {
                @if (isStack(part)) {
                    <fa-stack>
                        @for (l of $any(part).stack; track $index) {
                            <fa-icon
                                [icon]="$any(l.icon)"
                                [stackItemSize]="l.stackItemSize"
                                [transform]="l.transform"
                                [flip]="$any(l.flip)"
                                [rotate]="$any(l.rotate)"
                                [attr.style]="l.style" />
                        }
                    </fa-stack>
                } @else {
                    <fa-icon
                        [icon]="$any(part).icon"
                        [size]="$any(part).size ?? size()"
                        [transform]="$any(part).transform"
                        [flip]="$any(part).flip"
                        [rotate]="$any(part).rotate"
                        [attr.style]="$any(part).style" />
                }
            }
        </div>`,
    styleUrls: ['./icon.component.scss'],
    standalone: true,
    host: { class: 'icon' },
    imports: [FontAwesomeModule],
})
export class IconComponent {
    name = input.required<IconName>();
    title = input('');
    size = input<string | undefined>(undefined);

    protected readonly isStack = isStackPart;
    protected readonly def = computed(() => ICONS[this.name()]);
}
